<template lang='pug'>
  include ../mixins
  div
    +b.modal-close--video.BUTTON(@click="$emit('close')")
    +b.video
      +e.frame-wrapper
        +e.frame.IFRAME(
          :src='getVideo(objectItem.src)'
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen height='100%'
        )
</template>

<script>
export default {
  name: 'video-modal',
  props: {
    objectItem: Object,
  },
  methods: {
    getVideoId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
      const match = url.match(regExp)
      const eleven = 11
      if (match && match[2].length === eleven) {
        return match[2]
      }
      return 'error'
    },
    getVideoPreview(url) {
      const videoPreview = `//img.youtube.com/vi/${this.getVideoId(url)}/sddefault.jpg`
      return videoPreview
    },
    getVideo(el) {
      const item = `//www.youtube.com/embed/${this.getVideoId(el)}?autoplay=1`
      return item
    },
  },
}
</script>
